import { joinValidStrings } from './string';

const lastWithfirstInitial = ({ lastName, firstName }) => (
  firstName ? `${lastName} ${firstName[0].toUpperCase()}` : lastName
);

export const lastWithfirstInitialList = (authors = []) => joinValidStrings(
  authors.map(lastWithfirstInitial),
  ', '
);

const lastName = names => (names && names.lastName) || '';

export const tuncatedLastNameList = (authors = [], limit = 2) => {
  const primaryAuthor = lastName(authors[0]);

  if (!primaryAuthor) return '';

  if (authors.length > limit) return `${primaryAuthor} et al`;

  return joinValidStrings(authors.slice(0, 2).map(lastName), ', ');
};



// WEBPACK FOOTER //
// ./src/universal/ui/utils/format-author.js